(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.swiperThumbs = null;
        this.initialized = false;
      }

      connectedCallback() {
        this.swiperElement = this.querySelector('.js-swiper');
        this.swiperThumbsElement = this.querySelector('.js-swiper-thumbs');
        this.initialSlide = this.normalizeInitialSlide(Number(this.dataset.initialSlideIndex || 0));
        this.setInitialSlidePresentation(this.initialSlide);
        this.initWhenReady();
      }

      disconnectedCallback() {
        if (this.swiper) this.swiper.destroy(true, true);
        if (this.swiperThumbs) this.swiperThumbs.destroy(true, true);
        this.swiper = null;
        this.swiperThumbs = null;
        this.initialized = false;
      }

      initWhenReady(attempt = 0) {
        if (this.initialized) return;

        if (!window.Swiper) {
          if (attempt < 60) {
            window.setTimeout(() => this.initWhenReady(attempt + 1), 50);
          }
          return;
        }

        this.initThumbs();
        this.initMainGallery();
        this.initDesktopZoom();
        this.initialized = true;
      }

      initMainGallery() {
        if (!this.swiperElement) return;

        const slideCount = this.getSlideCount(this.swiperElement);
        if (slideCount === 0) return;

        const swiperNextButton = this.querySelector('.js-swiper-button-next');
        const swiperPrevButton = this.querySelector('.js-swiper-button-prev');
        const swiperPagination = this.querySelector('.swiper-pagination');
        const hasMultipleSlides = slideCount > 1;

        this.swiper = new Swiper(this.swiperElement, {
          initialSlide: this.initialSlide,
          slidesPerView: 1,
          spaceBetween: 0,
          loop: hasMultipleSlides,
          navigation:
            hasMultipleSlides && swiperNextButton && swiperPrevButton
              ? {
                  nextEl: swiperNextButton,
                  prevEl: swiperPrevButton,
                }
              : false,
          pagination:
            hasMultipleSlides && swiperPagination
              ? {
                  el: swiperPagination,
                  type: 'progressbar',
                }
              : false,
          thumbs: this.swiperThumbs ? { swiper: this.swiperThumbs } : undefined,
          breakpoints: {
            500: {
              spaceBetween: 2,
            },
            768: {
              spaceBetween: 2,
            },
          },
          on: {
            afterInit: () => {
              window.setTimeout(() => {
                swiperPrevButton?.classList.remove('loading');
                swiperNextButton?.classList.remove('loading');
                this.swiperElement.classList.remove('loading');
              }, 100);
            },
          },
        });
      }

      initThumbs() {
        if (!this.swiperThumbsElement) return;

        const slideCount = this.getSlideCount(this.swiperThumbsElement);
        if (slideCount <= 1) return;

        this.swiperThumbs = new Swiper(this.swiperThumbsElement, {
          spaceBetween: 12,
          slidesPerView: 5.5,
          direction: 'vertical',
          mousewheel: true,
          watchSlidesProgress: true,
        });
      }

      setActiveMedia(mediaId) {
        const activeSlide = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeSlide) return;

        const slideIndex = this.normalizeInitialSlide(Number(activeSlide.dataset.galleryIndex || 0));
        this.setInitialSlidePresentation(slideIndex);

        if (!this.swiper) {
          this.initialSlide = slideIndex;
          return;
        }

        if (this.swiper.params.loop && typeof this.swiper.slideToLoop === 'function') {
          this.swiper.slideToLoop(slideIndex, 0);
        } else {
          this.swiper.slideTo(slideIndex, 0);
        }
      }

      getSlideCount(swiperElement) {
        return swiperElement?.querySelectorAll('.swiper-wrapper > .swiper-slide').length || 0;
      }

      normalizeInitialSlide(slideIndex) {
        const slideCount = this.getSlideCount(this.swiperElement);
        const lastSlideIndex = Math.max(slideCount - 1, 0);

        if (Number.isNaN(slideIndex) || slideIndex < 0) return 0;

        return Math.min(slideIndex, lastSlideIndex);
      }

      setInitialSlidePresentation(slideIndex) {
        const normalizedSlideIndex = this.normalizeInitialSlide(slideIndex);

        this.dataset.initialSlideIndex = String(normalizedSlideIndex);
        this.style.setProperty('--product-gallery-initial-slide-index', normalizedSlideIndex);

        this.updateSlides(this.swiperElement, normalizedSlideIndex, false);
        this.updateSlides(this.swiperThumbsElement, normalizedSlideIndex, true);
      }

      updateSlides(swiperElement, slideIndex, useThumbActiveClass) {
        swiperElement?.querySelectorAll('.swiper-wrapper > .swiper-slide').forEach((slide, index) => {
          const isActive = index === slideIndex;
          slide.classList.toggle('is-initial-gallery-slide', isActive);
          if (useThumbActiveClass) slide.classList.toggle('swiper-slide-thumb-active', isActive);
        });
      }

      initDesktopZoom() {
        this.querySelectorAll('.tc-pdp-gallery__main .tc-pdp-gallery__media--image').forEach((imageContainer) => {
          if (imageContainer.dataset.zoomInitialized === 'true') return;

          const image = imageContainer.querySelector('img');
          if (!image) return;

          imageContainer.dataset.zoomInitialized = 'true';
          imageContainer.classList.add('zoomable-container');
          image.classList.add('zoomable-img');
          image.draggable = false;
          imageContainer.style.setProperty('--zoom', 3);

          imageContainer.addEventListener('mouseenter', () => {
            imageContainer.classList.add('zoomed');
          });

          imageContainer.addEventListener('mousemove', (event) => {
            const rect = imageContainer.getBoundingClientRect();
            const percentageX = `${((event.clientX - rect.left) * 100) / rect.width}%`;
            const percentageY = `${((event.clientY - rect.top) * 100) / rect.height}%`;

            imageContainer.style.setProperty('--zoom-pos-x', percentageX);
            imageContainer.style.setProperty('--zoom-pos-y', percentageY);
          });

          imageContainer.addEventListener('mouseleave', () => {
            imageContainer.classList.remove('zoomed');
          });
        });
      }
    }

    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
